// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/realtime.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/realtime.proto.
 */
export const file_cortado_v1_realtime: GenFile = /*@__PURE__*/
  fileDesc("Chljb3J0YWRvL3YxL3JlYWx0aW1lLnByb3RvEgpjb3J0YWRvLnYxIlcKD1NlYWxlZExpdmVRdWVyeRISCgpjYXBhYmlsaXR5GAEgASgJEhkKEXF1ZXJ5X2ZpbmdlcnByaW50GAIgASgJEhUKDWV4cGlyZXNfYXRfbXMYAyABKAMiagoNUmVhbHRpbWVRdWVyeRIsCgVxdWVyeRgBIAEoDjIdLmNvcnRhZG8udjEuUmVhbHRpbWVRdWVyeUVudW0SKwoGc2VhbGVkGAIgASgLMhsuY29ydGFkby52MS5TZWFsZWRMaXZlUXVlcnkiZAoZR2V0UmVhbHRpbWVRdWVyaWVzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSLgoHcXVlcmllcxgCIAMoDjIdLmNvcnRhZG8udjEuUmVhbHRpbWVRdWVyeUVudW0iZgoaR2V0UmVhbHRpbWVRdWVyaWVzUmVzcG9uc2USDwoHZW5hYmxlZBgBIAEoCBILCgN1cmwYAiABKAkSKgoHcXVlcmllcxgDIAMoCzIZLmNvcnRhZG8udjEuUmVhbHRpbWVRdWVyeSqjAQoRUmVhbHRpbWVRdWVyeUVudW0SHgoaUkVBTFRJTUVfUVVFUllfVU5TUEVDSUZJRUQQABIfChtSRUFMVElNRV9RVUVSWV9SRUNFTlRfTEVBRFMQARIpCiVSRUFMVElNRV9RVUVSWV9SRUNFTlRfQUNDRVBURURfUVVPVEVTEAISIgoeUkVBTFRJTUVfUVVFUllfUkVDRU5UX1BBWU1FTlRTEANCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM");

/**
 * SealedLiveQuery mirrors @neon/realtime's SealedLiveQuery. It is a bearer
 * credential for one exact query: never log it or persist it in the browser.
 *
 * @generated from message cortado.v1.SealedLiveQuery
 */
export type SealedLiveQuery = Message<"cortado.v1.SealedLiveQuery"> & {
  /**
   * Opaque encrypted capability.
   *
   * @generated from field: string capability = 1;
   */
  capability: string;

  /**
   * Stable identity of the exact query; renewals must match it.
   *
   * @generated from field: string query_fingerprint = 2;
   */
  queryFingerprint: string;

  /**
   * Capability expiry as Unix milliseconds.
   *
   * @generated from field: int64 expires_at_ms = 3;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message cortado.v1.SealedLiveQuery.
 * Use `create(SealedLiveQuerySchema)` to create a new message.
 */
export const SealedLiveQuerySchema: GenMessage<SealedLiveQuery> = /*@__PURE__*/
  messageDesc(file_cortado_v1_realtime, 0);

/**
 * @generated from message cortado.v1.RealtimeQuery
 */
export type RealtimeQuery = Message<"cortado.v1.RealtimeQuery"> & {
  /**
   * @generated from field: cortado.v1.RealtimeQueryEnum query = 1;
   */
  query: RealtimeQueryEnum;

  /**
   * @generated from field: cortado.v1.SealedLiveQuery sealed = 2;
   */
  sealed?: SealedLiveQuery;
};

/**
 * Describes the message cortado.v1.RealtimeQuery.
 * Use `create(RealtimeQuerySchema)` to create a new message.
 */
export const RealtimeQuerySchema: GenMessage<RealtimeQuery> = /*@__PURE__*/
  messageDesc(file_cortado_v1_realtime, 1);

/**
 * @generated from message cortado.v1.GetRealtimeQueriesRequest
 */
export type GetRealtimeQueriesRequest = Message<"cortado.v1.GetRealtimeQueriesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Queries to seal. Empty means every query the caller may see. Queries the
   * caller lacks permission for are omitted from the response, not refused.
   *
   * @generated from field: repeated cortado.v1.RealtimeQueryEnum queries = 2;
   */
  queries: RealtimeQueryEnum[];
};

/**
 * Describes the message cortado.v1.GetRealtimeQueriesRequest.
 * Use `create(GetRealtimeQueriesRequestSchema)` to create a new message.
 */
export const GetRealtimeQueriesRequestSchema: GenMessage<GetRealtimeQueriesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_realtime, 2);

/**
 * @generated from message cortado.v1.GetRealtimeQueriesResponse
 */
export type GetRealtimeQueriesResponse = Message<"cortado.v1.GetRealtimeQueriesResponse"> & {
  /**
   * False when Neon Realtime is not configured for this deployment. Clients
   * must then do nothing; url and queries are empty.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * Neon Realtime WebSocket URL for createRealtimeClient.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: repeated cortado.v1.RealtimeQuery queries = 3;
   */
  queries: RealtimeQuery[];
};

/**
 * Describes the message cortado.v1.GetRealtimeQueriesResponse.
 * Use `create(GetRealtimeQueriesResponseSchema)` to create a new message.
 */
export const GetRealtimeQueriesResponseSchema: GenMessage<GetRealtimeQueriesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_realtime, 3);

/**
 * RealtimeQueryEnum names one backend-defined live query.
 *
 * @generated from enum cortado.v1.RealtimeQueryEnum
 */
export enum RealtimeQueryEnum {
  /**
   * @generated from enum value: REALTIME_QUERY_UNSPECIFIED = 0;
   */
  REALTIME_QUERY_UNSPECIFIED = 0,

  /**
   * Most recent non-archived leads (events.inquiries). Needs Leads View.
   *
   * @generated from enum value: REALTIME_QUERY_RECENT_LEADS = 1;
   */
  REALTIME_QUERY_RECENT_LEADS = 1,

  /**
   * Most recently accepted quotes. Needs Quotes View.
   *
   * @generated from enum value: REALTIME_QUERY_RECENT_ACCEPTED_QUOTES = 2;
   */
  REALTIME_QUERY_RECENT_ACCEPTED_QUOTES = 2,

  /**
   * Most recent succeeded customer payments. Needs Payments View.
   *
   * @generated from enum value: REALTIME_QUERY_RECENT_PAYMENTS = 3;
   */
  REALTIME_QUERY_RECENT_PAYMENTS = 3,
}

/**
 * Describes the enum cortado.v1.RealtimeQueryEnum.
 */
export const RealtimeQueryEnumSchema: GenEnum<RealtimeQueryEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_realtime, 0);

